module.exports = __webpack_public_path__ + "img/spxzf.41f9c035.png";